import axios from 'axios'

const API = axios.create({baseURL: 'https://inven.herokuapp.com'})

API.interceptors.request.use( req => {
    if(localStorage.getItem('retailer')){
        req.headers.authorization = `Bearer ${JSON.parse(localStorage.getItem('retailer')).token}`
    }
    return req;
})

export const getProducts = () => API.get('/products')
export const createProduct = (product) => API.post('/products', product)
export const searchProducts = (searchQuery) => API.get(`/products/search?searchQuery=${searchQuery.search || 'none'}`);

export const login = (formData) => API.post('/retailers/login', formData)
export const register = (formData) => API.post('/retailers/register', formData)